// ─── Action Type Constants ────────────────────────────────────────────────────

export const LOAD_FAST_FEATURE_STATUS = 'LOAD_FAST_FEATURE_STATUS'
export const LOAD_FAST_FEATURE_STATUS_SUCCESS =
  'LOAD_FAST_FEATURE_STATUS_SUCCESS'

export const TOGGLE_FAST_FEATURE_STATUS = 'TOGGLE_FAST_FEATURE_STATUS'
export const TOGGLE_FAST_FEATURE_STATUS_SUCCESS =
  'TOGGLE_FAST_FEATURE_STATUS_SUCCESS'
export const TOGGLE_FAST_FEATURE_STATUS_FAILURE =
  'TOGGLE_FAST_FEATURE_STATUS_FAILURE'

export const SAVE_FAST_FEATURE_DETAILS = 'SAVE_FAST_FEATURE_DETAILS'
export const SAVE_FAST_FEATURE_DETAILS_SUCCESS =
  'SAVE_FAST_FEATURE_DETAILS_SUCCESS'
export const SAVE_FAST_FEATURE_DETAILS_FAILURE =
  'SAVE_FAST_FEATURE_DETAILS_FAILURE'

// ─── Action Creators ──────────────────────────────────────────────────────────

/**
 * Load the fast feature status for the given feature.
 * Dispatched when the Feature Editor mounts for an Active feature.
 */
export const loadFastFeatureStatus = ({ featureId }) => ({
  type: LOAD_FAST_FEATURE_STATUS,
  payload: { featureId },
})

/**
 * Toggle a feature's Fast Feature status on/off.
 * Triggers the watchToggleFastFeatureStatus saga.
 */
export const toggleFastFeatureStatus = ({ featureId, isFastFeature }) => ({
  type: TOGGLE_FAST_FEATURE_STATUS,
  payload: { featureId, isFastFeature },
})

/**
 * Save the Fast Feature output details for a feature.
 * Triggers the watchSaveFastFeatureDetails saga.
 */
export const saveFastFeatureDetails = ({
  featureId,
  featureNumber,
  description,
  ecuType,
  outputs,
  filterOutput,
}) => ({
  type: SAVE_FAST_FEATURE_DETAILS,
  payload: {
    featureId,
    featureNumber,
    description,
    ecuType,
    outputs,
    filterOutput,
  },
})
